export var PlatformName;
(function (PlatformName) {
    PlatformName["GOOGLE"] = "GOOGLE";
    PlatformName["LOCALCH"] = "LOCALCH";
    PlatformName["MYLOCALINA"] = "MyLOCALINA";
})(PlatformName || (PlatformName = {}));
